import { Play, Video } from "lucide-react";

const placeholders = [
  { name: "A Maqam Pilgrim", role: "October 2024 Traveller" },
  { name: "A Maqam Pilgrim", role: "First-Time Pilgrim" },
  { name: "A Maqam Pilgrim", role: "Family Traveller" },
];

export default function VideoTestimonials() {
  return (
    <section
      data-testid="video-testimonials"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="overline">Coming Soon</span>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl text-[color:var(--maqam-navy)] leading-[1.05] tracking-tight">
            Hear From Our Pilgrims
          </h2>
          <p className="mt-5 text-[var(--maqam-muted)] leading-relaxed">
            Short reflections, straight from the community. We're gathering these now — check back soon.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {placeholders.map((p, i) => (
            <article
              key={i}
              data-testid={`video-placeholder-${i}`}
              className="review-shadow-hover rounded-2xl overflow-hidden bg-[color:var(--maqam-navy)] text-white border border-[color:var(--maqam-navy)]"
            >
              <div className="relative aspect-[4/5] islamic-pattern-dark flex items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40" />
                <button
                  aria-label={`Play reflection from ${p.name}`}
                  className="relative inline-flex items-center justify-center w-16 h-16 rounded-full bg-[color:var(--maqam-gold)] hover:bg-[color:var(--maqam-gold-2)] transition-colors"
                >
                  <Play size={22} className="text-[color:var(--maqam-navy)] ml-1" style={{ fill: "currentColor" }} />
                </button>
                <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-white/70 border border-white/25 rounded-full px-2.5 py-1">
                  <Video size={10} /> Coming Soon
                </span>
              </div>
              <div className="px-6 py-5">
                <p className="font-semibold">{p.name}</p>
                <p className="text-xs text-white/60 mt-0.5 tracking-wide">{p.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
